import { atomWithStorage } from "jotai/utils";

export enum VehicleType {
  CAR = "CAR",
  MOTO = "MOTO",
  CARAVAN = "CARAVAN",
  ALL = "ALL"
}

export const dealerActiveVehicleFilterAtom = atomWithStorage<VehicleType[]>(
  "dealerActiveVehicleFilterAtom",
  [VehicleType.CAR, VehicleType.MOTO, VehicleType.CARAVAN],
  undefined,
  { getOnInit: true }
);
